import { isLocalDevHost, shouldEnforceDomainSplit } from '../constants/siteDomains';

const COOKIE_NAME = 'constela_has_session';
const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 30;

function cookieDomainAttribute(): string {
  if (typeof window === 'undefined') return '';
  const host = window.location.hostname;
  if (host.endsWith('constelabrasil.com.br')) {
    return '; domain=.constelabrasil.com.br';
  }
  return '';
}

function isSecureCookie(): boolean {
  return typeof window !== 'undefined' && window.location.protocol === 'https:';
}

/** Indica login ativo entre app.constelabrasil.com.br e constelabrasil.com.br. */
export function setSessionMarker(): void {
  if (typeof document === 'undefined') return;
  const secure = isSecureCookie() ? '; Secure' : '';
  document.cookie = `${COOKIE_NAME}=1; path=/; max-age=${COOKIE_MAX_AGE_SEC}; SameSite=Lax${secure}${cookieDomainAttribute()}`;
}

export function clearSessionMarker(): void {
  if (typeof document === 'undefined') return;
  const secure = isSecureCookie() ? '; Secure' : '';
  const expired = `${COOKIE_NAME}=; path=/; max-age=0; SameSite=Lax${secure}`;
  document.cookie = `${expired}${cookieDomainAttribute()}`;
  document.cookie = expired;
}

export function hasSessionMarker(): boolean {
  if (typeof document === 'undefined') return false;
  return document.cookie.split(';').some((part) => part.trim().startsWith(`${COOKIE_NAME}=1`));
}

/** Usuário logado nesta aba ou em outro subdomínio da Constela. */
export function hasCrossDomainSessionHint(isAuthenticated: boolean): boolean {
  if (isAuthenticated) return true;
  if (!shouldEnforceDomainSplit() || isLocalDevHost()) return false;
  return hasSessionMarker();
}
